import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeleteWorkspaceJoinRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWorkspaceJoinRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idInvitedMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestAccessModelType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"idInvitedMember"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idInvitedMember"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelType"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeleteWorkspaceJoinRequest","document":DeleteWorkspaceJoinRequestDocument}} as const;
export type DeleteWorkspaceJoinRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  idInvitedMember: Types.Scalars['ID']['input'];
  modelType: Types.RequestAccessModelType;
  signature: Types.Scalars['String']['input'];
  traceId: Types.Scalars['String']['input'];
}>;


export type DeleteWorkspaceJoinRequestMutation = (
  { __typename: 'Mutation' }
  & { deleteAccessRequest?: Types.Maybe<(
    { __typename: 'AccessRequest_Response' }
    & Pick<Types.AccessRequest_Response, 'success'>
  )> }
);

export type DeleteWorkspaceJoinRequestMutationFn = Apollo.MutationFunction<
  DeleteWorkspaceJoinRequestMutation,
  DeleteWorkspaceJoinRequestMutationVariables
>;

/**
 * __useDeleteWorkspaceJoinRequestMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceJoinRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceJoinRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceJoinRequestMutation, { data, loading, error }] = useDeleteWorkspaceJoinRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      idInvitedMember: // value for 'idInvitedMember'
 *      modelType: // value for 'modelType'
 *      signature: // value for 'signature'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useDeleteWorkspaceJoinRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkspaceJoinRequestMutation,
    DeleteWorkspaceJoinRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkspaceJoinRequestMutation,
    DeleteWorkspaceJoinRequestMutationVariables
  >(DeleteWorkspaceJoinRequestDocument, options);
}
export type DeleteWorkspaceJoinRequestMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceJoinRequestMutation
>;
export type DeleteWorkspaceJoinRequestMutationResult =
  Apollo.MutationResult<DeleteWorkspaceJoinRequestMutation>;
export type DeleteWorkspaceJoinRequestMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteWorkspaceJoinRequestMutation,
    DeleteWorkspaceJoinRequestMutationVariables
  >;
